export default "__VITE_ASSET__TQFCn3Jd__"